import * as React from 'react';
import { portfolio } from '../../../data/PortfolioData';
import { PortfolioListItem } from "../portfolio-list-item/PortfolioListItem";

export class PortfolioList extends React.Component<any,{}> {
    render() {
        const portfolioItems = portfolio.map((project, index) => (
            <PortfolioListItem
                key={project.id}
                id={project.id}
                title={project.title}
                client={project.client}
                date={project.date}
                excerpt={project.excerpt}
                image_url={project.image_url}
                background_url={project.background_url}
                background_color={project.background_color}
                links={project.links}
                flip_columns={index % 2 === 0}
            />
        ));

        return (
            <div>
                {portfolioItems}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/portfolio/portfolio-list/PortfolioList.tsx